/**
 * Combined Theme JavaScript
 * Extracted from index.html and collection-page.html
 * Includes universal functionality and page-specific code with safety checks
 */

document.addEventListener('DOMContentLoaded', () => {
  // ============================================================
  // UNIVERSAL CODE (runs on all pages)
  // ============================================================

  // Header scroll effect
  const header = document.getElementById('siteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // Mobile menu toggle
  const mobileMenuToggle = document.getElementById('mobileMenuToggle');
  const mobileNav = document.getElementById('mobileNav');
  const mobileNavOverlay = document.getElementById('mobileNavOverlay');

  if (mobileMenuToggle && mobileNav) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenuToggle.classList.toggle('active');
      mobileNav.classList.toggle('active');
      if (mobileNavOverlay) mobileNavOverlay.classList.toggle('active');
      document.body.classList.toggle('nav-open');
    });

    if (mobileNavOverlay) {
      mobileNavOverlay.addEventListener('click', () => {
        mobileMenuToggle.classList.remove('active');
        mobileNav.classList.remove('active');
        mobileNavOverlay.classList.remove('active');
        document.body.classList.remove('nav-open');
      });
    }

    // Close on nav link click
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenuToggle.classList.remove('active');
        mobileNav.classList.remove('active');
        if (mobileNavOverlay) mobileNavOverlay.classList.remove('active');
        document.body.classList.remove('nav-open');
      });
    });
  }

  // ============================================================
  // HORIZONTAL SCROLL PROGRESS BARS
  // ============================================================
  document.querySelectorAll('.categories-grid, .featured-grid').forEach(grid => {
    const container = grid.closest('.section-inner') || grid.closest('.featured-section');
    if (!container) return;
    const bar = container.querySelector('.scroll-progress-bar');
    if (!bar) return;

    let ticking = false;
    function updateProgress() {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 0) return;
      const pct = grid.scrollLeft / maxScroll;
      // Bar is 30% of track width, so max travel = (100/30 - 1) * 100 ≈ 233%
      bar.style.transform = 'translateX(' + (pct * 233) + '%)';
      ticking = false;
    }

    grid.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateProgress);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  });

  // ============================================================
  // INDEX PAGE SPECIFIC CODE
  // ============================================================

  // Check if this is the index page by looking for newsletter-related elements
  if (document.querySelector('.signup-form')) {
    // ---- Klaviyo-direct signup forms ----
    // Each .signup-form is a plain HTML <form>. On submit we POST to
    // Klaviyo's public /client/subscriptions/ endpoint with the email,
    // phone (normalised to E.164), name, and a Source property. Klaviyo
    // creates/updates the profile, subscribes them to the Newsletter list,
    // and its Shopify integration syncs the profile back onto a Shopify
    // customer record (including the phone, finally).
    const KLAVIYO_COMPANY_ID = 'W45cNt';
    const KLAVIYO_LIST_ID = 'W5fGTb';
    // 2025-04-15+ is required to send `subscriptions` on profile data via
    // /client/subscriptions/ — without it WhatsApp consent never gets set
    // and the welcome WhatsApp message won't fire.
    const KLAVIYO_API_REVISION = '2025-04-15';

    // Normalise UK phone numbers to E.164 (+447xxxxxxxxx).
    // Accepts: "07xxx", "+44 7xxx", "44 7xxx", "00 44 7xxx", with spaces /
    // dashes / parens. Returns the cleaned E.164 string, or '' if the
    // input doesn't look like a valid number after normalisation.
    function normalisePhoneUK(raw) {
      if (!raw) return '';
      let p = String(raw).replace(/[\s\-\(\)\.]/g, '');
      if (!p) return '';
      if (p.charAt(0) === '+') {
        // pass through
      } else if (p.indexOf('00') === 0) {
        p = '+' + p.slice(2);
      } else if (p.charAt(0) === '0') {
        p = '+44' + p.slice(1);
      } else if (p.indexOf('44') === 0) {
        p = '+' + p;
      } else if (/^[1-9]\d{8,}$/.test(p)) {
        p = '+44' + p;
      } else {
        p = '+' + p;
      }
      if (!/^\+[1-9]\d{6,14}$/.test(p)) return '';
      return p;
    }

    function getDoneState(form) {
      return form.querySelector('.signup-done, .newsletter-page-done');
    }

    function getStepOne(form) {
      return form.querySelector('.signup-step-1, .newsletter-page-form-active');
    }

    function showDone(form) {
      const step1 = getStepOne(form);
      const done = getDoneState(form);
      if (step1) step1.classList.add('hidden');
      if (done) done.classList.remove('hidden');
      // Fade intro copy alongside the form's done state
      const dataForm = form.getAttribute('data-form') || '';
      if (dataForm === 'nudge') {
        const nudge = form.closest('.newsletter-nudge-inner');
        if (nudge) nudge.querySelectorAll('.nudge-text, .nudge-subtext').forEach(el => el.classList.add('fade-out'));
      } else if (dataForm === 'main') {
        const content = form.closest('.newsletter-content');
        if (content) content.querySelectorAll('.newsletter-label, .newsletter-heading, .newsletter-body, .newsletter-note').forEach(el => el.classList.add('fade-out'));
      } else if (dataForm === 'newsletter-page') {
        const section = form.closest('.newsletter-page');
        if (section) section.querySelectorAll('.newsletter-page-label, .newsletter-page-heading, .newsletter-page-body').forEach(el => el.style.display = 'none');
      }
      if (dataForm === 'exit') {
        setTimeout(function() { closeExitOverlay(); }, 2500);
      }
    }

    function postToKlaviyo(payload) {
      const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID);
      return fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          'revision': KLAVIYO_API_REVISION
        },
        body: JSON.stringify(payload)
      });
    }

    document.querySelectorAll('.signup-form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const nameInput = form.querySelector('input[type="text"], input[name="name"]');
        const emailInput = form.querySelector('input[type="email"]');
        const phoneInput = form.querySelector('input[type="tel"]');

        const fullName = (nameInput && nameInput.value || '').trim();
        const email = (emailInput && emailInput.value || '').trim();
        const rawPhone = (phoneInput && phoneInput.value || '').trim();

        // Validate
        let ok = true;
        if (!fullName && nameInput) { nameInput.style.borderColor = '#c44'; ok = false; }
        if ((!email || email.indexOf('@') === -1) && emailInput) { emailInput.style.borderColor = '#c44'; ok = false; }
        if (!ok) return;

        const parts = fullName.split(/\s+/);
        const firstName = parts[0] || '';
        const lastName = parts.slice(1).join(' ') || '';

        const phone = rawPhone ? normalisePhoneUK(rawPhone) : '';
        if (rawPhone && !phone && phoneInput) {
          // Phone unparseable — flag visually, but still submit (without phone)
          phoneInput.style.borderColor = '#c44';
        }

        const source = form.getAttribute('data-form') || 'unknown';
        const sourceLabel = ({
          'nudge': 'Homepage Nudge',
          'footer': 'Footer',
          'exit': 'Exit Overlay',
          'newsletter-page': 'Newsletter Page',
          'main': 'Main Newsletter Section'
        })[source] || source;

        const profileAttrs = {
          email: email,
          first_name: firstName,
          last_name: lastName,
          subscriptions: {
            email: { marketing: { consent: 'SUBSCRIBED' } }
          },
          properties: {
            'Source': sourceLabel,
            'Source Slug': source
          }
        };
        if (phone) {
          profileAttrs.phone_number = phone;
          // Klaviyo's WhatsApp marketing consent is what unlocks delivery
          // of WhatsApp templates from flows/campaigns. Without this set,
          // the welcome WhatsApp won't fire even if the profile is on the
          // list and has WhatsApp Opt-in = true.
          profileAttrs.subscriptions.whatsapp = { marketing: { consent: 'SUBSCRIBED' } };
          profileAttrs.properties['WhatsApp Opt-in'] = true;
        }

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: sourceLabel,
              profile: {
                data: { type: 'profile', attributes: profileAttrs }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
            }
          }
        };

        const submitBtn = form.querySelector('button[type="submit"], .btn-primary, .newsletter-page-submit');
        const originalBtnText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Joining\u2026';
        }

        postToKlaviyo(payload).then(function(res) {
          if (res.status >= 200 && res.status < 300) {
            showDone(form);
          } else {
            // Klaviyo returned a 4xx/5xx — still show done state to avoid
            // confusing the user, and log for debugging.
            res.text().then(function(t) { console.error('Klaviyo signup error', res.status, t); });
            showDone(form);
          }
        }).catch(function(err) {
          console.error('Klaviyo signup network failure', err);
          showDone(form);
        }).finally(function() {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
          }
        });
      });
    });

    var hasDoneState = false;

    // Backwards-compatibility shims for any cached HTML that still calls
    // the old onclick handlers. New markup uses native form submission.
    function submitStep1(btn) {
      const form = btn.closest('.signup-form');
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
      else if (form) form.submit();
    }
    function submitStep2(btn) { /* no-op; step 2 removed */ }
    function skipStep2(btn) { /* no-op; step 2 removed */ }

    // Reset border colour on input focus
    document.querySelectorAll('.signup-form input').forEach(input => {
      input.addEventListener('focus', () => {
        input.style.borderColor = '';
      });
    });

    // Adapt the optional-phone placeholder to viewport width.
    // The longer "Mobile (optional — for WhatsApp alerts)" text gets
    // truncated on narrow screens, so swap to a shorter version below
    // the mobile breakpoint.
    function adjustPhonePlaceholders() {
      const isMobile = window.innerWidth <= 768;
      document.querySelectorAll('.signup-phone-input').forEach(input => {
        input.placeholder = isMobile
          ? 'Mobile (optional)'
          : 'Mobile (optional \u2014 for WhatsApp alerts)';
      });
    }
    adjustPhonePlaceholders();
    window.addEventListener('resize', adjustPhonePlaceholders);

    // Allow Enter key to submit
    document.querySelectorAll('.signup-form input').forEach(input => {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const step = input.closest('.signup-step');
          const btn = step.querySelector('.btn-primary');
          if (btn) btn.click();
        }
      });
    });

    // ---- Exit-intent overlay (desktop only, once per session) ----
    // Don't show the overlay if the user just completed a signup
    // (a .signup-done element rendered means the form posted successfully).
    let exitShown = hasDoneState;
    document.addEventListener('mouseout', (e) => {
      if (exitShown) return;
      if (e.clientY <= 0 && e.relatedTarget === null) {
        const exitOverlayEl = document.getElementById('exitOverlay');
        if (!exitOverlayEl) return;
        // If the page has a #newsletter section, only fire the exit
        // overlay if the user hasn't scrolled to it yet. If there's
        // no #newsletter section on this page, always fire.
        const newsletterSection = document.getElementById('newsletter');
        if (newsletterSection) {
          const rect = newsletterSection.getBoundingClientRect();
          if (rect.top <= 0) return;
        }
        exitOverlayEl.classList.add('visible');
        exitShown = true;
      }
    });

    function closeExitOverlay() {
      document.getElementById('exitOverlay').classList.remove('visible');
    }

    const exitOverlay = document.getElementById('exitOverlay');
    if (exitOverlay) {
      exitOverlay.addEventListener('click', (e) => {
        if (e.target === e.currentTarget) closeExitOverlay();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeExitOverlay();
    });
  }

  // ============================================================
  // COLLECTION PAGE SPECIFIC CODE
  // ============================================================

  // Check if this is the collection page by looking for filter-related elements
  if (document.querySelector('.filter-dropdown')) {
    // ---- State ----
    const activeFilterState = {
      type: [],
      subcategory: [],
      style: [],
      material: []
    };
    let currentSort = 'featured';

    // ---- Filter dropdown toggle ----
    function toggleFilter(filterName) {
      const dropdown = document.querySelector(`.filter-dropdown[data-filter="${filterName}"]`);
      const wasOpen = dropdown.classList.contains('open');

      // Close all dropdowns
      document.querySelectorAll('.filter-dropdown').forEach(d => d.classList.remove('open'));
      const sortDropdown = document.getElementById('sortDropdown');
      if (sortDropdown) sortDropdown.classList.remove('open');

      // Toggle the clicked one
      if (!wasOpen) {
        dropdown.classList.toggle('open');
        dropdown.querySelector('.filter-btn').classList.add('active');
      }

      // Remove active class from all filter buttons that aren't open
      document.querySelectorAll('.filter-dropdown:not(.open) .filter-btn').forEach(btn => {
        btn.classList.remove('active');
      });
    }

    function toggleSort() {
      const dropdown = document.getElementById('sortDropdown');
      if (!dropdown) return;

      const wasOpen = dropdown.classList.contains('open');

      // Close all dropdowns
      document.querySelectorAll('.filter-dropdown').forEach(d => {
        d.classList.remove('open');
        d.querySelector('.filter-btn').classList.remove('active');
      });

      if (!wasOpen) {
        dropdown.classList.add('open');
      } else {
        dropdown.classList.remove('open');
      }
    }

    // Close dropdowns on outside click
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.filter-dropdown') && !e.target.closest('.sort-dropdown')) {
        document.querySelectorAll('.filter-dropdown').forEach(d => {
          d.classList.remove('open');
          d.querySelector('.filter-btn').classList.remove('active');
        });
        const sortDropdown = document.getElementById('sortDropdown');
        if (sortDropdown) sortDropdown.classList.remove('open');
      }
    });

    // ---- Checkbox filter logic ----
    document.querySelectorAll('.filter-option input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        const filterType = e.target.dataset.filterType;
        const value = e.target.value;

        if (e.target.checked) {
          activeFilterState[filterType].push(value);
        } else {
          activeFilterState[filterType] = activeFilterState[filterType].filter(v => v !== value);
        }

        applyFilters();
        updateActiveFilterTags();
      });
    });

    // ---- Sort logic ----
    document.querySelectorAll('.sort-option').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.sort-option').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        currentSort = btn.dataset.sort;
        const sortDropdown = document.getElementById('sortDropdown');
        if (sortDropdown) sortDropdown.classList.remove('open');
        applyFilters();
      });
    });

    // ---- Apply filters & sort ----
    // Helper: check if any value in a space-separated data attribute
    // matches any value in the active filter array
    function matchesFilter(dataValue, filterValues) {
      if (filterValues.length === 0) return true;
      if (!dataValue) return false;
      const productValues = dataValue.split(' ');
      return filterValues.some(fv => productValues.includes(fv));
    }

    function applyFilters() {
      const cards = Array.from(document.querySelectorAll('.product-card'));
      let visibleCount = 0;

      cards.forEach(card => {
        const matchesType = matchesFilter(card.dataset.type, activeFilterState.type);
        const matchesSubcategory = matchesFilter(card.dataset.subcategory, activeFilterState.subcategory);
        const matchesStyle = matchesFilter(card.dataset.style, activeFilterState.style);
        const matchesMaterial = matchesFilter(card.dataset.material, activeFilterState.material);

        const visible = matchesType && matchesSubcategory && matchesStyle && matchesMaterial;
        card.style.display = visible ? '' : 'none';
        if (visible) visibleCount++;
      });

      // Sort visible cards
      const grid = document.getElementById('productGrid');
      if (grid) {
        const visibleCards = cards.filter(c => c.style.display !== 'none');

        visibleCards.sort((a, b) => {
          switch (currentSort) {
            case 'price-low':
              return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
            case 'price-high':
              return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
            case 'newest':
              return b.dataset.date.localeCompare(a.dataset.date);
            case 'name-az':
              return a.querySelector('.product-card-title').textContent.localeCompare(
                b.querySelector('.product-card-title').textContent
              );
            default:
              return 0;
          }
        });

        // Re-append in sorted order
        visibleCards.forEach(card => grid.appendChild(card));

        // Move no-results to end
        const noResults = document.getElementById('noResults');
        if (noResults) {
          grid.appendChild(noResults);
          noResults.style.display = visibleCount === 0 ? 'block' : 'none';
        }
      }

      // Update count
      const productCount = document.getElementById('productCount');
      if (productCount) {
        productCount.textContent = `${visibleCount} Product${visibleCount !== 1 ? 's' : ''}`;
      }
    }

    // ---- Active filter tags ----
    function updateActiveFilterTags() {
      const container = document.getElementById('activeFilters');
      if (!container) return;

      const allFilters = [];

      for (const [filterType, values] of Object.entries(activeFilterState)) {
        values.forEach(value => {
          allFilters.push({ filterType, value });
        });
      }

      if (allFilters.length === 0) {
        container.classList.remove('visible');
        container.innerHTML = '';
        return;
      }

      container.classList.add('visible');

      const labelMap = {
        'seating': 'Seating', 'tables': 'Tables', 'storage': 'Storage', 'garden': 'Garden', 'other': 'Other',
        'stools': 'Stools', 'benches': 'Benches', 'dining-chairs': 'Dining Chairs',
        'sofas-armchairs': 'Sofas & Armchairs', 'footstools': 'Footstools',
        'desks-work-tables': 'Desks & Work Tables', 'prep-tables-islands': 'Prep Tables & Islands',
        'side-console-tables': 'Side & Console Tables', 'coffee-tables': 'Coffee Tables', 'dining-tables': 'Dining Tables',
        'cabinets': 'Cabinets', 'shelving': 'Shelving', 'dressers': 'Dressers',
        'wardrobes': 'Wardrobes', 'chests': 'Chests', 'bookcases': 'Bookcases', 'sideboards': 'Sideboards',
        'art': 'Art', 'ceramics-pottery': 'Ceramics & Pottery', 'glassware': 'Glassware',
        'tableware': 'Tableware', 'lighting': 'Lighting', 'mirrors': 'Mirrors',
        'collectibles': 'Collectibles', 'accessories': 'Accessories',
        'mid-century': 'Mid-Century', 'rustic': 'Rustic', 'industrial': 'Industrial',
        'country': 'Country', 'scandinavian': 'Scandinavian',
        'oak': 'Oak', 'pine': 'Pine', 'teak': 'Teak', 'metal': 'Metal', 'mixed': 'Mixed'
      };

      container.innerHTML = allFilters.map(f =>
        `<span class="filter-tag">${labelMap[f.value] || f.value}<button onclick="removeFilter('${f.filterType}', '${f.value}')">&times;</button></span>`
      ).join('') + '<button class="clear-filters" onclick="clearAllFilters()">Clear all</button>';
    }

    function removeFilter(filterType, value) {
      activeFilterState[filterType] = activeFilterState[filterType].filter(v => v !== value);

      // Uncheck the corresponding checkbox
      const checkbox = document.querySelector(`input[data-filter-type="${filterType}"][value="${value}"]`);
      if (checkbox) checkbox.checked = false;

      applyFilters();
      updateActiveFilterTags();
    }

    function clearAllFilters() {
      for (const key of Object.keys(activeFilterState)) {
        activeFilterState[key] = [];
      }
      document.querySelectorAll('.filter-option input[type="checkbox"]').forEach(cb => cb.checked = false);
      applyFilters();
      updateActiveFilterTags();
    }

    // Expose filter internals to global scope for mobile drawer & load more
    window.activeFilterState = activeFilterState;
    window.matchesFilter = matchesFilter;
    window.applyFilters = applyFilters;
    window.updateActiveFilterTags = updateActiveFilterTags;
  }

  // ============================================================
  // FOOTER ACCORDION (mobile)
  // ============================================================
  function toggleFooterAccordion(btn) {
    btn.classList.toggle('active');
    const content = btn.nextElementSibling;
    content.classList.toggle('open');
  }

  // ============================================================
  // EXPOSE FUNCTIONS TO GLOBAL SCOPE
  // ============================================================
  // Expose functions used in onclick attributes
  if (typeof submitStep1 === 'function') window.submitStep1 = submitStep1;
  if (typeof submitStep2 === 'function') window.submitStep2 = submitStep2;
  if (typeof skipStep2 === 'function') window.skipStep2 = skipStep2;
  if (typeof showDone === 'function') window.showDone = showDone;
  if (typeof hideIntroText === 'function') window.hideIntroText = hideIntroText;
  if (typeof closeExitOverlay === 'function') window.closeExitOverlay = closeExitOverlay;
  window.toggleFooterAccordion = toggleFooterAccordion;
  if (typeof toggleFilter === 'function') window.toggleFilter = toggleFilter;
  if (typeof toggleSort === 'function') window.toggleSort = toggleSort;
  if (typeof removeFilter === 'function') window.removeFilter = removeFilter;
  if (typeof clearAllFilters === 'function') window.clearAllFilters = clearAllFilters;

  // ============================================================
  // MOBILE FILTER DRAWER
  // ============================================================
  function openMobileFilters() {
    var drawer = document.getElementById('mobileFilterDrawer');
    var overlay = document.getElementById('mobileFilterOverlay');
    if (drawer) {
      drawer.classList.add('active');
      drawer.offsetHeight; // force reflow for transition
    }
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Sync checkboxes from desktop state to mobile drawer
    if (window.activeFilterState) {
      document.querySelectorAll('#mobileFilterDrawer .filter-option input[type="checkbox"]').forEach(function(cb) {
        var filterType = cb.dataset.filterType;
        var value = cb.value;
        if (window.activeFilterState[filterType]) {
          cb.checked = window.activeFilterState[filterType].includes(value);
        }
      });
    }
  }

  function closeMobileFilters() {
    var drawer = document.getElementById('mobileFilterDrawer');
    var overlay = document.getElementById('mobileFilterOverlay');
    if (drawer) drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';

    // Sync mobile selections back to state and desktop checkboxes
    syncMobileFiltersToDesktop();
  }

  function syncMobileFiltersToDesktop() {
    if (!window.activeFilterState) return;

    // Reset state
    for (var key of Object.keys(window.activeFilterState)) {
      window.activeFilterState[key] = [];
    }

    // Read from mobile drawer
    document.querySelectorAll('#mobileFilterDrawer .filter-option input[type="checkbox"]').forEach(function(cb) {
      if (cb.checked) {
        var filterType = cb.dataset.filterType;
        var value = cb.value;
        if (window.activeFilterState[filterType]) {
          window.activeFilterState[filterType].push(value);
        }
      }
    });

    // Sync desktop checkboxes
    document.querySelectorAll('.filter-bar .filter-option input[type="checkbox"]').forEach(function(cb) {
      var filterType = cb.dataset.filterType;
      var value = cb.value;
      if (window.activeFilterState[filterType]) {
        cb.checked = window.activeFilterState[filterType].includes(value);
      }
    });

    if (window.applyFilters) window.applyFilters();
    if (window.updateActiveFilterTags) window.updateActiveFilterTags();
    if (window.initLoadMore) window.initLoadMore();
  }

  function toggleMobileFilterSection(btn) {
    btn.classList.toggle('open');
    btn.nextElementSibling.classList.toggle('open');
  }

  window.openMobileFilters = openMobileFilters;
  window.closeMobileFilters = closeMobileFilters;
  window.toggleMobileFilterSection = toggleMobileFilterSection;

  // ============================================================
  // LOAD MORE FUNCTIONALITY
  // ============================================================
  var PRODUCTS_PER_PAGE = 12;
  var loadMoreCurrentCount = 0;

  function cardMatchesFilters(card) {
    if (!window.activeFilterState) return true;
    if (!window.matchesFilter) return true;
    return window.matchesFilter(card.dataset.type, window.activeFilterState.type) &&
           window.matchesFilter(card.dataset.subcategory, window.activeFilterState.subcategory) &&
           window.matchesFilter(card.dataset.style, window.activeFilterState.style) &&
           window.matchesFilter(card.dataset.material, window.activeFilterState.material);
  }

  function initLoadMore() {
    var grid = document.getElementById('productGrid');
    var container = document.getElementById('loadMoreContainer');
    if (!grid || !container) return;

    var allCards = Array.from(grid.querySelectorAll('.product-card'));
    var visibleCards = allCards.filter(function(c) { return cardMatchesFilters(c); });
    var total = visibleCards.length;

    loadMoreCurrentCount = Math.min(PRODUCTS_PER_PAGE, total);

    visibleCards.forEach(function(card, i) {
      card.style.display = i < loadMoreCurrentCount ? '' : 'none';
    });

    // Hide filtered-out cards
    allCards.filter(function(c) { return !cardMatchesFilters(c); }).forEach(function(card) {
      card.style.display = 'none';
    });

    updateLoadMoreUI(total);
  }

  function loadMoreProducts() {
    var grid = document.getElementById('productGrid');
    if (!grid) return;

    var allCards = Array.from(grid.querySelectorAll('.product-card'));
    var filterableCards = allCards.filter(function(c) { return cardMatchesFilters(c); });
    var total = filterableCards.length;
    var newCount = Math.min(loadMoreCurrentCount + PRODUCTS_PER_PAGE, total);

    filterableCards.forEach(function(card, i) {
      if (i < newCount) card.style.display = '';
    });

    loadMoreCurrentCount = newCount;
    updateLoadMoreUI(total);
  }

  function updateLoadMoreUI(total) {
    var btn = document.getElementById('loadMoreBtn');
    var container = document.getElementById('loadMoreContainer');
    var visibleCountEl = document.getElementById('visibleCount');
    var totalCountEl = document.getElementById('totalCount');
    var barFill = document.getElementById('loadMoreBarFill');

    if (visibleCountEl) visibleCountEl.textContent = loadMoreCurrentCount;
    if (totalCountEl) totalCountEl.textContent = total;
    if (barFill) barFill.style.width = total > 0 ? ((loadMoreCurrentCount / total) * 100) + '%' : '100%';
    if (btn) btn.style.display = (loadMoreCurrentCount >= total) ? 'none' : '';
    if (container) container.classList.toggle('hidden', total === 0);
  }

  // Override applyFilters to integrate with load more
  if (document.getElementById('productGrid') && document.getElementById('loadMoreContainer')) {
    var originalApplyFilters = window.applyFilters || null;

    // Patch: after filters are applied, re-initialize load more
    if (originalApplyFilters) {
      window.applyFilters = function() {
        originalApplyFilters();
        initLoadMore();
      };
    }

    // Initial run
    setTimeout(initLoadMore, 50);
  }

  window.loadMoreProducts = loadMoreProducts;
  window.initLoadMore = initLoadMore;

  // ============================================================
  // PRODUCT PAGE — Image gallery, variant selector, share, enquire
  // ============================================================

  // --- Gallery navigation ---
  function galleryGoTo(index) {
    var count = window.productImageCount || 0;
    if (count === 0) return;

    // Clamp / wrap index
    if (index < 0) index = count - 1;
    if (index >= count) index = 0;

    window.currentImageIndex = index;

    // Toggle active class on all gallery images — no src swap, instant display
    var allImages = document.querySelectorAll('.product-gallery-main .product-main-image');
    allImages.forEach(function(img, i) {
      img.classList.toggle('active', i === index);
    });

    // Update active thumbnail (desktop)
    document.querySelectorAll('.product-thumbnail').forEach(function(t) { t.classList.remove('active'); });
    var activeThumb = document.querySelector('.product-thumbnail[data-index="' + index + '"]');
    if (activeThumb) activeThumb.classList.add('active');

    // Update active dot (mobile)
    document.querySelectorAll('.gallery-dot').forEach(function(dot, i) {
      dot.classList.toggle('active', i === index);
    });
  }

  function galleryPrev() {
    galleryGoTo((window.currentImageIndex || 0) - 1);
  }

  function galleryNext() {
    galleryGoTo((window.currentImageIndex || 0) + 1);
  }

  // --- Mobile swipe support ---
  (function() {
    const galleryMain = document.querySelector('.product-gallery-main');
    if (!galleryMain) return;

    let touchStartX = 0;
    let touchEndX = 0;

    galleryMain.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    galleryMain.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          galleryNext();
        } else {
          galleryPrev();
        }
      }
    }, { passive: true });
  })();

  // --- Variant selector ---
  function updateVariant(selectEl) {
    const selectedOption = selectEl.options[selectEl.selectedIndex];
    const price = selectedOption.dataset.price;

    // Update displayed price
    const priceEl = document.querySelector('.product-info-price');
    if (priceEl && price) {
      priceEl.textContent = price;
    }

    // Update the hidden form input
    const variantInput = document.querySelector('.product-actions input[name="id"]');
    if (variantInput) {
      variantInput.value = selectEl.value;
    }

    // Toggle sold out state
    const addBtn = document.querySelector('.btn-add-to-cart');
    if (addBtn) {
      if (selectedOption.disabled) {
        addBtn.textContent = 'Sold';
        addBtn.disabled = true;
        addBtn.classList.add('btn-sold-out');
      } else {
        addBtn.textContent = 'Add to Cart';
        addBtn.disabled = false;
        addBtn.classList.remove('btn-sold-out');
      }
    }
  }

  // --- Share button ---
  function shareProduct() {
    const url = window.location.href;
    const title = document.querySelector('.product-info-title');
    const titleText = title ? title.textContent.trim() : document.title;

    // Use native Web Share API if available (mobile)
    if (navigator.share) {
      navigator.share({
        title: titleText,
        url: url
      }).catch(() => {});
    } else {
      // Fallback: copy link to clipboard
      navigator.clipboard.writeText(url).then(() => {
        const msg = document.getElementById('shareCopiedMsg');
        if (msg) {
          msg.classList.add('visible');
          setTimeout(() => msg.classList.remove('visible'), 2000);
        }
      }).catch(() => {
        // Last resort fallback
        const input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        const msg = document.getElementById('shareCopiedMsg');
        if (msg) {
          msg.classList.add('visible');
          setTimeout(() => msg.classList.remove('visible'), 2000);
        }
      });
    }
  }

  // --- Enquire / Make an Offer toggle ---
  function toggleEnquireOptions() {
    const options = document.getElementById('enquireOptions');
    if (!options) return;
    options.classList.toggle('visible');
  }

  // Close enquire options when clicking outside
  document.addEventListener('click', function(e) {
    const options = document.getElementById('enquireOptions');
    const btn = document.getElementById('btnEnquire');
    if (options && btn && !btn.contains(e.target) && !options.contains(e.target)) {
      options.classList.remove('visible');
    }
  });

  window.galleryGoTo = galleryGoTo;
  window.galleryPrev = galleryPrev;
  window.galleryNext = galleryNext;
  window.updateVariant = updateVariant;
  window.shareProduct = shareProduct;
  window.toggleEnquireOptions = toggleEnquireOptions;

  // ============================================================
  // CART DRAWER
  // ============================================================
  function openCartDrawer() {
    document.getElementById('cartDrawer').classList.add('active');
    document.getElementById('cartOverlay').classList.add('active');
    document.body.classList.add('cart-open');
  }

  function closeCartDrawer() {
    document.getElementById('cartDrawer').classList.remove('active');
    document.getElementById('cartOverlay').classList.remove('active');
    document.body.classList.remove('cart-open');
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(res => res.json())
    .then(cart => {
      // Refresh the page to update the cart drawer contents
      // (Shopify Liquid needs to re-render the cart items)
      window.location.reload();
    })
    .catch(err => console.error('Cart update error:', err));
  }

  // Intercept Add to Cart forms to use the drawer instead of redirecting
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(item => {
        // Update cart count in header
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const countEls = document.querySelectorAll('.cart-count, #cartCount, .cart-drawer-count');
            countEls.forEach(el => {
              if (el.classList.contains('cart-drawer-count')) {
                el.textContent = '(' + cart.item_count + ')';
              } else {
                el.textContent = cart.item_count;
              }
            });
            // Reload to get updated drawer HTML, then open it
            window.location.reload();
          });
      })
      .catch(err => console.error('Add to cart error:', err));
    });
  });

  // Close cart on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
    }
  });

  // Auto-open cart drawer if items were just added (via URL param)
  if (window.location.search.includes('cart_open=1')) {
    openCartDrawer();
    // Clean URL
    const url = new URL(window.location);
    url.searchParams.delete('cart_open');
    window.history.replaceState({}, '', url);
  }

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.updateCartItem = updateCartItem;

  // (Newsletter-page form is now a Liquid {% form 'customer' %} block
  // and is handled by the universal .signup-form submit handler above.
  // The previous AJAX-based approach was broken — Shopify rejects /contact
  // POSTs that don't carry Liquid-rendered auth tokens.)
});
